<template>
  <div style="width: 100%; padding: 20px">
    <div class="waste_name">{{ itemName }}</div>
    <div class="waste_amonunt">{{ itemAmount }}</div>
    <div class="waste_unit">{{ itemWeight }}</div>
    <div class="item_label">再資源化</div>
    <v-divider />
    <div v-if="dataCount > 0">
      <div class="bottom_container_total_chart">
        <div
          style="
            width: 100%;
            height: 125px;
            display: inline-flex;
            box-sizing: border-box;
          "
        >
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="simpleReuseWidth"
            v-bind:adjustedWidth="getWidth(simpleReuseWidth)"
            v-bind:itemPercentage="simpleReusePercentage"
            v-bind:itemText="simpleReuseText"
            v-bind:itemTotal="simpleReuseTotal"
            v-bind:itemColor="getBarColor('SimpleReuse')"
            marginLeftPixel="'0px'"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="creativeWidth"
            v-bind:adjustedWidth="getWidth(creativeWidth)"
            v-bind:itemPercentage="creativePercentage"
            v-bind:itemText="creativeText"
            v-bind:itemTotal="creativeTotal"
            v-bind:itemColor="getBarColor('CreativeReuse')"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="recycleWidth"
            v-bind:adjustedWidth="getWidth(recycleWidth)"
            v-bind:itemPercentage="recyclePercentage"
            v-bind:itemText="recycleText"
            v-bind:itemTotal="recycleTotal"
            v-bind:itemColor="getBarColor('Recycle')"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="chemicalRecycleWidth"
            v-bind:adjustedWidth="getWidth(chemicalRecycleWidth)"
            v-bind:itemPercentage="chemicalRecyclePercentage"
            v-bind:itemText="chemicalRecycleText"
            v-bind:itemTotal="chemicalRecycleTotal"
            v-bind:itemColor="getBarColor('ChemicalRecycle')"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="materialRecycleWidth"
            v-bind:adjustedWidth="getWidth(materialRecycleWidth)"
            v-bind:itemPercentage="materialRecyclePercentage"
            v-bind:itemText="materialRecycleText"
            v-bind:itemTotal="materialRecycleTotal"
            v-bind:itemColor="getBarColor('MaterialRecycle')"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="thermalRecycleWidth"
            v-bind:adjustedWidth="getWidth(thermalRecycleWidth)"
            v-bind:itemPercentage="thermalRecyclePercentage"
            v-bind:itemText="thermalRecycleText"
            v-bind:itemTotal="thermalRecycleTotal"
            v-bind:itemColor="getBarColor('ThermalRecycle')"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="afterIncinerationRecycleWidth"
            v-bind:adjustedWidth="getWidth(afterIncinerationRecycleWidth)"
            v-bind:itemPercentage="afterIncinerationRecyclePercentage"
            v-bind:itemText="afterIncinerationRecycleText"
            v-bind:itemTotal="afterIncinerationRecycleTotal"
            v-bind:itemColor="getBarColor('AfterIncinerationRecycle')"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="incinerationWidth"
            v-bind:adjustedWidth="getWidth(incinerationWidth)"
            v-bind:itemPercentage="incinerationPercentage"
            v-bind:itemText="incinerationText"
            v-bind:itemTotal="incinerationTotal"
            v-bind:itemColor="getBarColor('Incineration')"
          />
          <RecycleTypeChartBar
            v-bind:unitText="unitText"
            v-bind:itemWidth="landfillWidth"
            v-bind:adjustedWidth="getWidth(landfillWidth)"
            v-bind:itemPercentage="landfillPercentage"
            v-bind:itemText="landfillText"
            v-bind:itemTotal="landfillTotal"
            v-bind:itemColor="getBarColor('Landfill')"
          />
        </div>
      </div>
    </div>
    <div v-else style="width: 100%; height: 150px">
      <DataNotFound />
    </div>
    <div class="item_label">パーツ・結果</div>
    <v-divider />
    <div v-if="dataCount > 0">
      <div style="margin-top: 10px">
        <PartsResultHorizontalBarChart
          v-bind:receivedData="receivedDataForPartsResult"
        />
      </div>
    </div>
    <div v-else style="width: 100%; height: 150px">
      <DataNotFound />
    </div>
  </div>
</template>

<script>
import utils from '../../mixins/utils'
import PartsResultHorizontalBarChart from './PartsResultHorizontalBarChart'
import RecycleTypeChartBar from '../dashboard/RecycleTypeChartBar'
import DataNotFound from '../common/DataNotFound'
import RecycleTypeItems from '../../consts/RecycleTypeItems.js'

export default {
  name: 'ResultChartComponent',
  components: { PartsResultHorizontalBarChart, RecycleTypeChartBar, DataNotFound },
  props: {
    receivedData: {
      type: Object,
      default: () => {}
    },
    receivedDataForPartsResult: {
      type: Object,
      default: () => {}
    },
    reportId: {
      type: Number,
      default: 1,
    },
    itemInfo: {
      type: Object,
      default: () => {}
    },
  },
  mixins: [utils],
  data() {
    return {
      dataCount: 0,
      itemName: '',
      itemAmount: '',
      itemWeight: '',
      unitText: 't',
      simpleReuseText: '単純リユース',
      recycleText: 'リサイクル',
      creativeText: 'クリエイティブ',
      chemicalRecycleText: 'ケミカルリサイクル',
      materialRecycleText: 'マテリアルリサイクル',
      thermalRecycleText: 'サーマルリサイクル',
      afterIncinerationRecycleText: '焼却後リサイクル',
      incinerationText: '単純焼却',
      landfillText: '埋立',
      totalAmount: 1872.7,
      simpleReuseWidth: 20,
      creativeWidth: 20,
      recycleWidth: 20,
      chemicalRecycleWidth: 20,
      thermalRecycleWidth: 20,
      afterIncinerationRecycleWidth: 20,
      incinerationWidth: 20,
      materialRecycleWidth: 20,
      landfillWidth: 20,
      simpleReusePercentage: 0.0,
      creativePercentage: 0.0,
      recyclePercentage: 0.0,
      chemicalRecyclePercentage: 0.0,
      materialRecyclePercentage: 0.0,
      thermalRecyclePercentage: 0.0,
      afterIncinerationRecyclePercentage: 0.0,
      incinerationPercentage: 0.0,
      landfillPercentage: 0.0,
      receivedDataForRecycleRatio: {},
      incinerationTotal: 0,
      recycleTotal: 0,
      chemicalRecycleTotal: 0,
      materialRecycleTotal: 0,
      thermalRecycleTotal: 0,
      afterIncinerationRecycleTotal: 0,
      landfillTotal: 0,
      creativeTotal: 0,
      simpleReuseTotal: 0
    }
  },
  mounted() {
    this.refreshChart()
  },
  methods: {
    refreshChart() {
      let keys = Object.keys(this.receivedData)
      this.dataCount = keys.length

      this.itemName = this.itemInfo.name == null ? '廃棄物名無し' : this.itemInfo.name
      this.itemInfo.totalWeight = this.itemInfo.totalWeight != null ? this.itemInfo.totalWeight : 0
      this.itemInfo.itemWeight = this.itemInfo.itemWeight != null ? this.itemInfo.itemWeight : 0
      this.itemAmount = this.convertToFormattedNumber(this.itemInfo.totalWeight) + this.itemInfo.totalWeightScale
      this.itemWeight = this.itemInfo.itemWeight + this.itemInfo.itemWeightScale + '/個'
  
      this.incinerationTotal = this.getTotal(this.receivedData.Incineration)
      this.recycleTotal = this.getTotal(this.receivedData.Recycle)
      this.chemicalRecycleTotal = this.getTotal(this.receivedData.ChemicalRecycle)
      this.materialRecycleTotal = this.getTotal(this.receivedData.MaterialRecycle)
      this.thermalRecycleTotal = this.getTotal(this.receivedData.ThermalRecycle)
      this.afterIncinerationRecycleTotal = this.getTotal(this.receivedData.AfterIncinerationRecycle)
      this.landfillTotal = this.getTotal(this.receivedData.Landfill)
      this.creativeTotal = this.getTotal(this.receivedData.CreativeReuse)
      this.simpleReuseTotal = this.getTotal(this.receivedData.SimpleReuse)

      this.totalAmount = this.incinerationTotal + this.chemicalRecycleTotal +  this.materialRecycleTotal
               +  this.thermalRecycleTotal + this.afterIncinerationRecycleTotal + this.landfillTotal +  this.creativeTotal +  this.simpleReuseTotal +  this.recycleTotal

      this.receivedDataForRecycleRatio = {
        recycleWeight: (this.chemicalRecycleTotal + this.materialRecycleTotal + this.thermalRecycleTotal + this.creativeTotal +
                        this.simpleReuseTotal + this.recycleTotal) * 1000, // kgからgramに戻す
        wasteWeight: ( this.incinerationTotal + this.landfillTotal) * 1000, // kgからgramに戻す
      }

      this.simpleReusePercentage = this.simpleReuseTotal / this.totalAmount * 100
      this.creativePercentage = this.creativeTotal / this.totalAmount * 100
      this.recyclePercentage = this.recycleTotal / this.totalAmount * 100
      this.chemicalRecyclePercentage = this.chemicalRecycleTotal / this.totalAmount * 100
      this.materialRecyclePercentage = this.materialRecycleTotal / this.totalAmount * 100
      this.thermalRecyclePercentage = this.thermalRecycleTotal / this.totalAmount * 100
      this.afterIncinerationRecyclePercentage = this.afterIncinerationRecycleTotal / this.totalAmount * 100
      this.incinerationPercentage = this.incinerationTotal / this.totalAmount * 100
      this.landfillPercentage = this.landfillTotal / this.totalAmount * 100

      if(this.totalAmount < 1000.0) {
        this.unitText = "kg"
      } else {
        this.totalAmount = this.totalAmount / 1000
        this.incinerationTotal = this.incinerationTotal / 1000
        this.chemicalRecycleTotal = this.chemicalRecycleTotal / 1000
        this.materialRecycleTotal = this.materialRecycleTotal / 1000
        this.thermalRecycleTotal = this.thermalRecycleTotal / 1000
        this.afterIncinerationRecycleTotal = this.afterIncinerationRecycleTotal / 1000
        this.recycleTotal = this.recycleTotal / 1000
        this.landfillTotal = this.landfillTotal / 1000
        this.creativeTotal = this.creativeTotal / 1000
        this.simpleReuseTotal = this.simpleReuseTotal / 1000
        this.unitText = "t"
      }
  
      this.simpleReuseWidth = this.getAdjustedWidth(this.simpleReusPercentage)
      this.creativeWidth = this.getAdjustedWidth(this.creativePercentage)
      this.recycleWidth = this.getAdjustedWidth(this.recyclePercentage)
      this.chemicalRecycleWidth = this.getAdjustedWidth(this.chemicalRecyclePercentage)
      this.materialRecycleWidth = this.getAdjustedWidth(this.materialRecyclePercentage)
      this.thermalRecycleWidth = this.getAdjustedWidth(this.thermalRecyclePercentage)
      this.afterIncinerationRecycleWidth = this.getAdjustedWidth(this.afterIncinerationRecyclePercentage)
      this.incinerationWidth = this.getAdjustedWidth(this.incinerationPercentage)
      this.landfillWidth = this.getAdjustedWidth(this.landfillPercentage)
  
      this.redrawChart()
    },
    getTotal(jsonObject) {
      if(jsonObject == null) {
        return 0
      }
      let total = 0
      for (var item in jsonObject) {
        total += jsonObject[item] / 1000 // gram to kg
      }
      return total
    },
    getWidth(value) {
      if(value <= 5) {
        return '5%'
      }
      return value + '%'
    },
    getAdjustedWidth(widthValue) {
      if(widthValue <= 0) {
        return 0
      }
      if(widthValue < 5) {
       return 5 
      }
      return widthValue
    },
    getCountOfWidthBelow5() {
      let array = [this.simpleReusePercentage, this.creativePercentage, this.chemicalRecyclePercentage, this.materialRecyclePercentage,
             this.thermalRecyclePercentage, this.afterIncinerationRecyclePercentage, this.incinerationPercentage, this.landfillPercentage]
      let filtered = array.filter(function(value) {
        return (value > 0) && (value < 5)
      })
      return filtered.length
    },
    getCountOfWidth0(){
      let array = [this.simpleReusePercentage, this.creativePercentage, this.chemicalRecyclePercentage, this.materialRecyclePercentage,
             this.thermalRecyclePercentage, this.afterIncinerationRecyclePercentage, this.incinerationPercentage, this.landfillPercentage]
      let filtered = array.filter(function(value) {
        return value == 0
      })
      return filtered.length
    },
    adjustZeroPercentageWidth() {
      let array = [this.simpleReuseWidth, this.creativeWidth, this.recycleWidth, this.chemicalRecycleWidth, this.materialRecycleWidth,
             this.thermalRecycleWidth, this.afterIncinerationRecycleWidth, this.incinerationWidth, this.landfillWidth]
      let filtered = array.filter(function(value) {
        return value > 5
      })
      var countOfWidth0 = this.getCountOfWidth0()
      if (this.simpleReuseWidth > 5) {
        this.simpleReuseWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.creativeWidth > 5) {
        this.creativeWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.recycleWidth > 5) {
        this.recycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.chemicalRecycleWidth > 5) {
        this.chemicalRecycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.materialRecycleWidth > 5) {
        this.materialRecycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.thermalRecycleWidth > 5) {
        this.thermalRecycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.afterIncinerationRecycleWidth > 5) {
        this.afterIncinerationRecycleWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.incinerationWidth > 5) {
        this.incinerationWidth += countOfWidth0 * 5 / filtered.length
      }
      if (this.landfillWidth > 5) {
        this.landfillWidth += countOfWidth0 * 5 / filtered.length
      }
    },
    redrawChart() {
      let adjustedWidth = (100 - (this.getCountOfWidthBelow5() * 5)) / 100
      // 0%のものが混ざっていた場合の考慮を入れる
      this.adjustZeroPercentageWidth()
      if(adjustedWidth == 1) return
  
      if(this.simpleReuseWidth > 5) {
        this.simpleReuseWidth = this.simpleReuseWidth * adjustedWidth
      }
  
      if(this.creativeWidth > 5) {
        this.creativeWidth = this.creativeWidth * adjustedWidth
      }

      if(this.recycleWidth > 5) {
        this.recycleWidth = this.recycleWidth * adjustedWidth
      }
  
      if(this.chemicalRecycleWidth > 5) {
        this.chemicalRecycleWidth = this.chemicalRecycleWidth * adjustedWidth
      }
  
      if(this.materialRecycleWidth > 5) {
        this.materialRecycleWidth = this.materialRecycleWidth * adjustedWidth
      }
  
      if(this.thermalRecycleWidth > 5) {
        this.thermalRecycleWidth = this.thermalRecycleWidth * adjustedWidth
      }

      if(this.afterIncinerationRecycleWidth > 5) {
        this.afterIncinerationRecycleWidth = this.afterIncinerationRecycleWidth * adjustedWidth
      }

      if(this.incinerationWidth > 5) {
        this.incinerationWidth = this.incinerationWidth * adjustedWidth
      }
  
      if(this.landfillWidth > 5) {
        this.landfillWidth = this.landfillWidth * adjustedWidth
      }
    },
    getBarColor(name) {
      const selectedRecycleType = RecycleTypeItems.filter(
        function (recycleType) {
          if (recycleType.value == name) return recycleType
        }
      )
      return selectedRecycleType[0].color
    }
  }
}
</script>

<style scoped>
.bottom_container_total_chart {
  border-top: solid 1px rgba(52, 58, 63, 0.1);
  padding-top: 15px;
  text-align: center;
}

.type_name_text {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  word-wrap: brek-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: start;
}

.total_chart_graph {
  border-radius: 8px;
  display: grid;
  grid-template-rows: 2fr 4fr 1fr;
  box-sizing: border-box;
}

.total_chart_graph_bottom_grid {
  display: grid;
  grid-template-columns: 6fr 5fr 2fr;
}

.chart_label_container {
  display: flex;
  align-self: center;
}

.center_aligned_container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.width_auto {
  width: auto;
}

.waste_name {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #343a3f;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 10px;
}

.waste_amonunt {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  color: #491d8b;
  margin-bottom: 10px;
}

.waste_unit {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #697077;
}

.item_label {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #333333;
  margin-top: 40px;
  margin-bottom: 10px;
}

.recycle_item_button {
  padding: 8px;
  height: 32px;
  background: #4db380;
  border-radius: 16px;
  color: #ffffff;
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.clickable:hover {
  cursor: pointer;
}
</style>
